import React from 'react'
import { FormattedMessage } from 'react-intl'
import ResultsComparisonPieChart from './results-comparison-piechart'
import { ResultsComparisonGraphs } from './results-comparison-graphs'

export const ResultsComparison = ({
  carbonImpact,
  airTravel,
  transportation,
  householdAndDiet,
  region,
  type
}) => {
  return (
    <section className="ciicc-section">
      <div className="ciicc-wrap -narrow">
        <div className="mb-34">
          <h2 className="text-header-primary-color semibold font-32">
            <FormattedMessage id="results.comparison.title" />
          </h2>
          <p>
            <FormattedMessage id="results.comparison.subtitle" />
          </p>
        </div>
        <div className="ciicc-results-comparison">
          <ResultsComparisonPieChart
            carbonImpact={carbonImpact}
            airTravel={airTravel}
            transportation={transportation}
            householdAndDiet={householdAndDiet}
          />
          <ResultsComparisonGraphs
            airTravel={airTravel}
            transportation={transportation}
            householdAndDiet={householdAndDiet}
            region={region}
            type={type}
          />
        </div>
      </div>
    </section>
  )
}
